import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { GREY_LIGHTER_COLOR, TEXT_GREY } from '@CSSVars/colors'


export const _MlsDisclaimer = styled.div`
  ${({ withBg }) => (withBg ? `
    border-top: 1px solid ${GREY_LIGHTER_COLOR};
    padding: 15px 0;

    img {
      float: left;
      width: 80px;
      margin-top: 14px;
      margin-right: 10px;
    }
  ` : `
    img {
      float: left;
      width: 80px;
      margin-right: 10px;
    }
  `)}
`

export const _Disclaimer = styled.p`
  font-size: 12px;
  color: ${TEXT_GREY};
`
